<template>
  <div style="margin-top: 2.7vw">
    <div v-show="orderStatus===1||orderStatus===2" >
      <div v-for="(order,index) in orderList.waitApprovedOrderList" v-show="chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)" class="row1" @click="toDetailInfo(1,order)">
        <div class="container_9">
          <span class="info_6" :lines="undefined">下单成员：{{order.orderPerson}}</span>
          <div class="outer_2" >
            <div class="color_2 color_red">
              未审批
            </div>
            <svg data-v-c24bfab2="" t="1583809028111" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="15" height="15" class="liveiconput"><path data-v-c24bfab2="" d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
          </div>

        </div>
        <div class="div_4" />
        <!--商品信息-->
        <div v-for="(item,i) in order.itemList" style="width: 100%; padding: 0 15px;">
          <div class="block-item" style="height: 80px;" v-if="order.fromEmkt">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <img v-else class="largeIcon" :src=serviceUrl />
              <div class="item-detail" v-if="item.categoryId">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0" >
                   <span v-for="title in item._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._subTitleList && item._subTitleList.length > 0" >
                  <span v-for="(subTitle, index) in item._subTitleList">
                    <span v-if="index !== 0">/</span>
                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._abstractList && item._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in item._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
              </div>
              <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   {{item.name}}
                </span>
                <span class="light-text-color small-font">
                  <span>
                    {{ stringSet(item.serviceItemDetail.productInfoList[0])}}
                  </span>
                </span>
                <span class="light-text-color small-font">
                   <span>
                     {{item.serviceItemDetail.productInfoList[1]}}
                   </span>
                </span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="item.productType === emkt.PRODUCT_TYPE_TOOL">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <div class="item-detail">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;">{{item.name}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden">{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item.tax">{{item.tax}} <span v-if="item.symbol">{{item.symbol}}</span></span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="(item.productType !== emkt.PRODUCT_TYPE_TOOL)&&(item.contractNoSrc===''||item.contractNoSrc===undefined)">
            <div class="tabbarserviceselWrap">
              <img
                class="iconTest"
                src="static/img/service_product.png"
              />
            </div>
            <div class="item-detail">
              <span class="deep-text-color" style="font-size: 12px;">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="empty_2" />
        <div class="container_6">
          <span class="text_5" :lines="undefined"
          >下单时间：{{order.orderTime}}</span
          >
          <div class="moneyWrap">
            <span class="word_4" :lines="undefined">共{{order.itemList.length}}件商品</span>
            <span class="text_6" :lines="undefined">合计</span>
            <span class="money" :lines="undefined">￥{{splitMoney(order.price)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderStatus===1||orderStatus===3">
      <div v-for="(order,index) in orderList.executedOrderList" v-show="chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)"class="row1" @click="toDetailInfo(2,order)">
        <div class="container_9">
          <span class="info_6" :lines="undefined">下单成员：{{order.orderPerson}}</span>
          <div class="outer_2" >
            <div class="color_2 color_orange">
              执行中
            </div>
            <svg data-v-c24bfab2="" t="1583809028111" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="15" height="15" class="liveiconput"><path data-v-c24bfab2="" d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
          </div>

        </div>
        <div class="div_4" />
        <!--商品信息-->
        <div v-for="(item,i) in order.itemList" style="width: 100%; padding: 0 15px;">
          <div class="block-item" style="height: 80px;" v-if="order.fromEmkt">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <img v-else class="largeIcon" :src=serviceUrl />
              <div class="item-detail" v-if="item.categoryId">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0" >
                   <span v-for="title in item._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._subTitleList && item._subTitleList.length > 0" >
                  <span v-for="(subTitle, index) in item._subTitleList">
                    <span v-if="index !== 0">/</span>
                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._abstractList && item._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in item._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
              </div>
              <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   {{item.name}}
                </span>
                <span class="light-text-color small-font">
                  <span>
                    {{ stringSet(item.serviceItemDetail.productInfoList[0])}}
                  </span>
                </span>
                <span class="light-text-color small-font">
                   <span>
                     {{item.serviceItemDetail.productInfoList[1]}}
                   </span>
                </span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="item.productType === emkt.PRODUCT_TYPE_TOOL">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <div class="item-detail">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;">{{item.name}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden">{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item.tax">{{item.tax}} <span v-if="item.symbol">{{item.symbol}}</span></span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="(item.productType !== emkt.PRODUCT_TYPE_TOOL)&&(item.contractNoSrc===''||item.contractNoSrc===undefined)">
            <div class="tabbarserviceselWrap">
              <img
                class="iconTest"
                src="static/img/service_product.png"
              />
            </div>
            <div class="item-detail">
              <span class="deep-text-color" style="font-size: 12px;">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="empty_2" />
        <div class="container_6">
          <span class="text_5" :lines="undefined"
          >下单时间：{{order.orderTime}}</span
          >
          <div class="moneyWrap">
            <span class="word_4" :lines="undefined">共{{order.itemList.length}}件商品</span>
            <span class="text_6" :lines="undefined">合计</span>
            <span class="money" :lines="undefined">￥{{splitMoney(order.price)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderStatus===1||orderStatus===4"  >
      <div v-for="(order,index) in orderList.finishedOrderList"  v-show="chooseStatus===1||(chooseStatus===2&&chooseMemberName===order.orderPerson)" class="row1" @click="toDetailInfo(2,order)">
        <div class="container_9">
          <span class="info_6" :lines="undefined">下单成员：{{order.orderPerson}}</span>
          <div class="outer_2" >
            <div class="color_2 color_greeen">
              已完成
            </div>
            <svg data-v-c24bfab2="" t="1583809028111" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="15" height="15" class="liveiconput"><path data-v-c24bfab2="" d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
          </div>

        </div>
        <div class="div_4" />
        <!--商品信息-->
        <div v-for="(item,i) in order.itemList" style="width: 100%; padding: 0 15px;">
          <div class="block-item" style="height: 80px;" v-if="order.fromEmkt">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <img v-else class="largeIcon" :src=serviceUrl />
              <div class="item-detail" v-if="item.categoryId">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0" >
                   <span v-for="title in item._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._subTitleList && item._subTitleList.length > 0" >
                  <span v-for="(subTitle, index) in item._subTitleList">
                    <span v-if="index !== 0">/</span>
                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                  </span>
                </span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._abstractList && item._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in item._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
              </div>
              <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   {{item.name}}
                </span>
                <span class="light-text-color small-font">
                  <span>
                    {{ stringSet(item.serviceItemDetail.productInfoList[0])}}
                  </span>
                </span>
                <span class="light-text-color small-font">
                   <span>
                     {{item.serviceItemDetail.productInfoList[1]}}
                   </span>
                </span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="item.productType === emkt.PRODUCT_TYPE_TOOL">
            <div class="block-address">
              <img v-if="item.merchandiseIcon"
                   class="largeIcon"
                   :src=baseurl+item.merchandiseIcon
              />
              <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                   class="largeIcon"
                   :src=baseurl+emkt.CUSTOMIZE_IMAGE
              />
              <div class="item-detail">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;">{{item.name}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden">{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span>
                <span class="light-text-color tiny-font text-overflow-hidden" v-if="item.tax">{{item.tax}} <span v-if="item.symbol">{{item.symbol}}</span></span>
              </div>
            </div>
            <span class="light-text-color">X {{item.quantity}}</span>
          </div>
          <div class="block-item" style="height: 80px;" v-else-if="(item.productType !== emkt.PRODUCT_TYPE_TOOL)&&(item.contractNoSrc===''||item.contractNoSrc===undefined)">
            <div class="tabbarserviceselWrap">
              <img
                class="iconTest"
                src="static/img/service_product.png"
              />
            </div>
            <div class="item-detail">
              <span class="deep-text-color" style="font-size: 12px;">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="empty_2" />
        <div class="container_6">
          <span class="text_5" :lines="undefined"
          >下单时间：{{order.orderTime}}</span
          >
          <div class="moneyWrap">
            <span class="word_4" :lines="undefined">共{{order.itemList.length}}件商品</span>
            <span class="text_6" :lines="undefined">合计</span>
            <span class="money" :lines="undefined">￥{{splitMoney(order.price)}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapState} from 'vuex'
  import EMKT from '../../../../emkt'

  export default {
    name: 'OrderInfoList',
    props: {
      orderStatus: Number,
      orderListOrigin: Object,
      chooseMemberName: String,
      chooseStatus: Number
    },
    data () {
      return {
        monthlyTotalApprovedAmount: 0,
        orderList: [],
        baseurl: '/emktResources/resocurces/img/merchandise/',
        serviceUrl: '/emktResources/resocurces/img/merchandise/service.png'
      }
    },
    mounted () {
      this.orderList = EMKT.getLocalStorage('ResearchGroupOrderList')
    },
    computed: {
      ...mapState([
        'researchGroupMemberMap'
      ]),
      ...mapGetters([
        'displayChosenResearchGroup', 'researchGroupCharacter'
      ]),
      memberList () {
        if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return
        if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return
        const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
        var totalMemberList = this.researchGroupMemberMap[researchGroupNo]
        var doubleList = [[]]
        var num = 0 // 已经循环的成员总数
        for (var i = 0; i <= (totalMemberList.length + 1) / 3; i++) {
          doubleList[i] = []
          let k = 0 // 每行的成员总数
          for (var j = num; j < totalMemberList.length; j++) {
            if ((i === 0 && k < 2) || (i !== 0 && k < 3)) {
              doubleList[i][k] = totalMemberList[j]
              num++
              k++
            } else {
              break
            }
          }
        }
        console.log('课题组成员二维数组', doubleList)
        // return this.researchGroupMemberMap[researchGroupNo]
        return doubleList
      },
      memberList1 () {
        if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return
        if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return
        const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
        return this.researchGroupMemberMap[researchGroupNo]
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_CHOSEN_ORDER', 'UPDATE_CHOSEN_MEMBER', 'UPDATE_TOTAL_APPROVE_AMOUNT'
      ]),
      toDetailInfo: function (status, order) {
        this.UPDATE_CHOSEN_ORDER(order)
        EMKT.setLocalStorage('ResearchGroupOrder', order)
        console.log('订单信息', order)
        var memberInfo = {}
        for (let i = 0; i < this.memberList1.length; i++) {
          if (order.orderPerson === this.memberList1[i].memberName) {
            memberInfo = this.memberList1[i]
            break
          }
        }
        this.UPDATE_CHOSEN_MEMBER(memberInfo)
        console.log('下单成员信息', memberInfo)
        if (status === 1) {
          this.gcapi('getMonthlyTotalApprovedAmount', order.id).then(res => {
            console.log('月度累计限额：', res.data)
            if (res.data.code === 0) {
              this.monthlyTotalApprovedAmount = res.data.result
              this.UPDATE_TOTAL_APPROVE_AMOUNT(this.monthlyTotalApprovedAmount)
            } else {
              console.log('获取月度累计限额失败')
            }
          })
        }

        this.$router.push({name: 'OrderDetailInfo', query: {status: status, routeType: 1, orderNo: order.orderNo}})
        // this.$router.push({name: 'OrderDetailInfo', query: {routeType: 2, orderNo: order.orderNo, researchGroupNo: this.displayChosenResearchGroup.researchGroupNo}})
      },
      splitMoney (moneyNumber) {
        if (moneyNumber === undefined) {
          return ''
        }
        return String(moneyNumber).split('.')[0].replace(/\B(?=(?:\d{3})+\b)/g, ',')
      },
      stringSet (str) {
        if (str) {
          let s = str.replace(/&nbsp;/ig, ' ')
          return s
        } else {
          return ''
        }
      }
    }
  }
</script>

<style scoped>
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 75%;
  }
  .deep-text-color {
    color: #424242;
    font-size: 12px;
    /*font-weight: 500;*/
    font-weight: bold;
  }
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .block-item {
    height: 35px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .split-line {
    border-top: .7px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }

  .text-overflow-hidden {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  row {
    position: relative;
    margin-top: 2.4vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.67vw;
    height: 0.27vw;
  }

  .row1 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 2.7vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    padding-bottom: 2.73vw;
  }

  .group_2 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.4vw;
    width: 86.4vw;
    height: 5.33vw;
  }

  .color_2 {
    position: absolute;
    right: 4.53vw;
    border-radius: 1.87vw;
    width: 11.2vw;
    height: 3.73vw;
    color: white;
    text-align: center;
    font-size: 2.67vw;
    font-weight: 400;
    line-height: 4.23vw;
  }
  .text_0 {
    display: inline-block;
    font-size: 2.73vw;
    position: absolute;
    top:-0.1vw;
    right: 1.4vw;
    transform: scale(0.8)
  }

  .color_red{
    background-color:#fe654d
  }
  .color_greeen {
    background-color: #60d837;
  }
  .color_orange{
    background-color: #ff9400;
  }

  .color_3 {
    position: absolute;
    right: 4.53vw;
    border-radius: 1.87vw;
    background-color: red;
    width: 12.2vw;
    height: 4.73vw;
    font-size: x-small;
    color: white;
    text-align: center;
  }
  .info_2 {
    position: relative;
    opacity: 1;
    max-width: 69.07vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 500;
  }

  .outer_2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    height:  3.73vw;
  }


  .div_2 {
    position: relative;
    margin-top: 2.13vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.93vw;
    height: 13.87vw;
    left: 3.73vw
  }

  .gfpPuromycin {
    top: 2.4vw;
    left: 28.07vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .block_4 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    width: 48.8vw;
    height: 13.87vw;
    margin-left: -13vw;
  }

  .word_2 {
    position: absolute;
    top: 2.4vw;
    left: 0vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: inline-block;
    width: 62.2vw;
    height: 6vw;
  }

  .largeIcon {
    position: relative;
    margin-right: 1.33vw;
    width: 13.87vw;
    height: 13.87vw;
  }

  .humanatgnm {
    position: relative;
    opacity: 1;
    margin-top: 6.93vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: inline-block;
    width: 70.2vw;
    height: 6vw;
  }

  .txt_5 {
    position: relative;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
  }


  .empty_2 {
    position: relative;
    margin-top: 3.2vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_6 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.2vw;
    width: 86.67vw;
    height: 5.6vw;
  }

  .text_5 {
    opacity: 1;
    max-width: 51.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .moneyWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.6vw;
  }

  .word_4 {
    opacity: 1;
    margin-right: 1.33vw;
    max-width: 14.67vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .text_6 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .money {
    opacity: 1;
    max-width: 15.73vw;
    height: 5.33vw;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .type2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    height: 42.47vw;
  }


  .colorDiv_3 {
    position: absolute;
    right: 0.73vw;
    border-radius: 1.87vw;
    background-color: #ff9400;
    width: 12.2vw;
    height: 4.73vw;
    font-size: x-small;
    color: white;
    text-align: center;

  }


  .container_9 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.4vw;
    width: 84.8vw;
    height: 5.87vw;
  }

  .info_6 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 500;
  }



  .div_4 {
    position: relative;
    margin-top: 1.6vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .block_9 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 4vw;
    margin-left: 4vw;
    height: 12.53vw;
  }

  .tabbarserviceselWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 2.4vw;
    width: 12.53vw;
    height: 12.53vw;
  }

  .iconTest {
    position: absolute;
    top: 0;
    left: 0;
    width: 12.53vw;
    height: 12.53vw;
    overflow: hidden;
  }


  .info_7 {
    opacity: 1;
    margin-top: 1.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
    margin-left: 2vw;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: inline-block;
    width: 65.2vw;
    height: 6vw;
  }



  .price_2 {
    opacity: 1;
    margin-top: 1.6vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .bg {
    position: relative;
    margin-top: 1.07vw;
    margin-left: 3.73vw;
    width: 90.67vw;
    height: 0.53vw;
  }

  .container_10 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.67vw;
    height: 5.6vw;
  }

  .txt_10 {
    opacity: 1;
    max-width: 64.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .moneyWrap_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.6vw;
  }

  .txt_11 {
    opacity: 1;
    max-width: 9.07vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .money_2 {
    opacity: 1;
    max-width: 22.4vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// OrderInfoList.vue?4640f320